import { swap } from '@/utils/utils'
import toast from '@/utils/toast'

function syncZIndexByOrder(componentData) {
    if (!Array.isArray(componentData)) {
        return
    }
    componentData.forEach((item, ind) => {
        if (item && item.style) {
            item.style.zIndex = ind + 1
        }
    })
}

function resolveIndex(state) {
    const { componentData, curComponent, curComponentIndex } = state
    if (
        Number.isInteger(curComponentIndex) &&
        componentData[curComponentIndex] &&
        curComponent &&
        componentData[curComponentIndex].id === curComponent.id
    ) {
        return curComponentIndex
    }
    if (!curComponent) {
        return -1
    }
    return componentData.findIndex((c) => c && c.id === curComponent.id)
}

function minMovableIndex(componentData) {
    const backIndex = componentData.findIndex((c) => c && c.id === 'Back')
    return backIndex === -1 ? 0 : backIndex + 1
}

export default {
    mutations: {
        upComponent(state) {
            const { componentData, curComponent } = state
            if (!curComponent || curComponent.id === 'Back') {
                toast('背景不能调整层级')
                return
            }
            const index = resolveIndex(state)
            if (index < 0) {
                return
            }
            if (index < componentData.length - 1) {
                swap(componentData, index, index + 1)
                state.curComponentIndex = index + 1
                syncZIndexByOrder(componentData)
            } else {
                toast('已经到顶了')
            }
        },

        downComponent(state) {
            const { componentData, curComponent } = state
            if (!curComponent || curComponent.id === 'Back') {
                toast('背景不能调整层级')
                return
            }
            const index = resolveIndex(state)
            if (index < 0) {
                return
            }
            const minIndex = minMovableIndex(componentData)
            if (index > minIndex) {
                swap(componentData, index, index - 1)
                state.curComponentIndex = index - 1
                syncZIndexByOrder(componentData)
            } else {
                toast('已经到底了')
            }
        },

        topComponent(state) {
            const { componentData, curComponent } = state
            if (!curComponent || curComponent.id === 'Back') {
                toast('背景不能调整层级')
                return
            }
            const index = resolveIndex(state)
            if (index < 0) {
                return
            }
            if (index < componentData.length - 1) {
                componentData.splice(index, 1)
                componentData.push(curComponent)
                state.curComponentIndex = componentData.length - 1
                syncZIndexByOrder(componentData)
            } else {
                toast('已经到顶了')
            }
        },

        bottomComponent(state) {
            const { componentData, curComponent } = state
            if (!curComponent || curComponent.id === 'Back') {
                toast('背景不能调整层级')
                return
            }
            const index = resolveIndex(state)
            if (index < 0) {
                return
            }
            const minIndex = minMovableIndex(componentData)
            if (index > minIndex) {
                componentData.splice(index, 1)
                componentData.splice(minIndex, 0, curComponent)
                state.curComponentIndex = minIndex
                syncZIndexByOrder(componentData)
            } else {
                toast('已经到底了')
            }
        },
    },
}
